import { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/free-solid-svg-icons';
import { useAuth } from '../../context/AuthContext';

const PacientesMedico = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [pacientes, setPacientes] = useState([]);

  useEffect(() => {
    if (user?.rol === 'doctor') {
      fetchPacientes(user.id); // usamos el id del doctor logueado
    }
  }, [user]);

  const fetchPacientes = async (idmedico) => {
    try {
      const res = await axios.get(`/api/medicos/pacientes/${idmedico}`);
      setPacientes(res.data);
    } catch (error) {
      console.error('Error al obtener pacientes:', error);
    }
  };

  const verDetallePaciente = (iduser) => {
    navigate(`/doctor/pacientes/${iduser}`);
  };

  return (
    <div className="p-6">
      <div className="backdrop-blur-md bg-white/30 shadow-md rounded-2xl p-6">
        <h2 className="text-2xl font-bold mb-4">Pacientes del Médico</h2>

        <div className="overflow-x-auto">
          <table className="w-full border-collapse">
            <thead>
              <tr className="bg-white/40">
                <th className="p-3 text-left">Nombre</th>
                <th className="p-3 text-left">Email</th>
                <th className="p-3 text-left">Edad</th>
                <th className="p-3 text-left">Teléfono</th>
                <th className="p-3 text-left">Fecha asignación</th>
                <th className="p-3 text-center">Acciones</th>
              </tr>
            </thead>
            <tbody>
              {pacientes.length > 0 ? (
                pacientes.map((p) => (
                  <tr key={p.iduser} className="border-b border-white/40">
                    <td className="p-3">{p.name} {p.apellidos}</td>
                    <td className="p-3">{p.email}</td>
                    <td className="p-3">{p.edad || 'N/A'}</td>
                    <td className="p-3">{p.telefono || 'N/A'}</td>
                    <td className="p-3">{new Date(p.fecha_asignacion).toLocaleDateString()}</td>
                    <td className="p-3 text-center">
                      <button
                        onClick={() => verDetallePaciente(p.iduser)}
                        className="bg-blue-500 hover:bg-blue-600 text-white px-3 py-2 rounded-full shadow-md transition"
                      >
                        <FontAwesomeIcon icon={faEye} />
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="8" className="text-center p-4">No hay pacientes asignados</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default PacientesMedico;
